import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBand } from "@/components/site/TrustBand";
import { Insurers } from "@/components/site/Insurers";
import { Help } from "@/components/site/Help";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Situations } from "@/components/site/Situations";
import { Calculator } from "@/components/site/Calculator";
import { HowWeWork } from "@/components/site/HowWeWork";
import { Testimonials } from "@/components/site/Testimonials";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { CookieBanner } from "@/components/site/CookieBanner";
import { FloatingWa } from "@/components/landing/FloatingWa";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <>
      <a href="#contenido" className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[70] focus:rounded-lg focus:bg-white focus:p-3">Saltar al contenido</a>
      <Header />
      <main id="contenido" data-testid="landing-page" className="overflow-x-clip">
        <Hero />
        <TrustBand />
        <Insurers />
        <Help />
        <HowItWorks />
        <Situations />
        <Calculator />
        <HowWeWork />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingWa />
      <CookieBanner />
    </>
  );
}
